import {Injectable, OnDestroy, OnInit} from '@angular/core';
import * as Stomp from '@stomp/stompjs';
import SockJS from 'sockjs-client';
import {ResponseSnackbarService} from '@ucx/ui-cmp';
import {environment} from '../../../environments/environment';
import {TokenService} from './token.service';

@Injectable()
export class WebSocketService implements OnInit, OnDestroy {

  constructor(
    protected responseSnackBar: ResponseSnackbarService,
    private tokenService: TokenService) {
  }

  /**
   * Is web socket connected.
   */
  connected = false;
  /**
   * Stomp client.
   */
  stompClient = null;

  /**
   * Ng on init.
   */
  ngOnInit() {
    this.connect();
  }

  ngOnDestroy() {
    if (this.stompClient != null) {
      this.stompClient.deactivate();
    }
  }

  /**
   * Set connected.
   *
   * @param connected Is connected.
   */
  setConnected(connected: boolean) {
    this.connected = connected;
  }

  /**
   * Connect.
   */
  connect() {
    if (!this.connected) {
      if (!this.tokenService.isAuthenticated()) {
        return;
      }
      this.stompClient = new Stomp.Client();
      this.stompClient.webSocketFactory = () => {
        return new SockJS(`${environment.api}/portal-ws`);
      };

      this.stompClient.onStompError = (frame) => {
        console.error('Broker reported error: ' + frame.headers.message);
        console.error('Additional details: ' + frame.body);
      };
      this.stompClient.activate();
      this.setConnected(true);
    }
  }

  /**
   *  Disconnect Websocket.
   */
  disconnect() {
    if (this.stompClient != null) {
      this.stompClient.deactivate();
    }
    this.setConnected(false);
  }
}
